<template>
  <AdminShell :page-title="pageTitle" :page-subtitle="pageSubtitle" active-menu="promotion">
    <template #actions>
      <el-button plain @click="goToList">返回列表</el-button>
      <el-button v-if="form.id && !isReadonlyAdminView" plain @click="goToBills">账单明细</el-button>
      <el-button v-if="form.id && !isReadonlyAdminView" type="danger" plain :loading="deleting" @click="deleteCurrent">
        删除推广
      </el-button>
      <el-button v-if="!isReadonlyAdminView" plain :loading="draftSaving" @click="saveDraft">
        保存草稿
      </el-button>
      <el-button v-if="!isReadonlyAdminView" type="primary" :loading="saving" @click="savePromotion">
        保存推广
      </el-button>
    </template>

    <section class="promotion-editor-page" :class="{ 'is-readonly': isReadonlyAdminView }" v-loading="pageLoading">
      <el-form ref="formRef" :model="form" :rules="rules" :disabled="isReadonlyAdminView" label-position="top"
        class="editor-layout" @submit.native.prevent>
        <div class="editor-form">
          <article class="editor-card">
            <div class="section-head">
              <div>
                <h2>推广基础信息</h2>
              </div>
              <span class="status-pill" :class="`is-${form.campaign.status}`">
                {{ statusLabel(form.campaign.status) }}
              </span>
            </div>

            <div class="grid-two">
              <el-form-item label="推广名称" prop="campaign.name">
                <el-input v-model.trim="form.campaign.name" placeholder="例如：新广告系列" />
              </el-form-item>

              <el-form-item label="推广目标" prop="campaign.objective">
                <el-select v-model="form.campaign.objective" placeholder="请选择推广目标">
                  <el-option v-for="item in objectiveOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>

              <!-- <el-form-item label="转化位置">
                <el-select v-model="form.ad_set.conversion_location">
                  <el-option label="网站" value="website" />
                  <el-option label="直播间" value="live_room" />
                  <el-option label="消息" value="messages" />
                </el-select>
              </el-form-item> -->

              <el-form-item :label="URLlabel">
                <el-input v-model.trim="form.ad_set.landing_url" placeholder="https://example.com/landing" />
              </el-form-item>

              <!-- <el-form-item label="优化目标">
                <el-select v-model="form.ad_set.optimization_goal">
                  <el-option label="落地页浏览" value="landing_page_views" />
                  <el-option label="购买" value="purchases" />
                  <el-option label="消息" value="messages" />
                  <el-option label="覆盖人数" value="reach" />
                </el-select>
              </el-form-item> -->

              
              <el-form-item v-if="currentAd" label="按钮">
                <el-select v-model="currentAd.cta">
                  <el-option v-for="item in ctaOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>

              <el-form-item label="预算类型">
                <el-select v-model="form.campaign.budget_type">
                  <el-option label="单日预算" value="daily" />
                  <el-option label="总预算" value="lifetime" />
                </el-select>
              </el-form-item>

              <el-form-item label="预算金额(USD)">
                <div class="budget-block">
                  <el-slider v-model="form.campaign.budget_amount" :min="1" :max="10000" :step="10" :show-input="true"
                    :show-tooltip="false" />
                </div>
              </el-form-item>

              <!-- <el-form-item label="币种">
                <el-input v-model.trim="form.campaign.currency" placeholder="例如：USD" />
              </el-form-item> -->

              <el-form-item label="推广时间">
                <el-select v-model="timeType">
                  <el-option :value="0" label="立即推广(长期)"></el-option>
                  <el-option :value="1" label="指定时间"></el-option>
                </el-select>
                <el-date-picker v-if="timeType" v-model="durationRange" type="datetimerange" unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss" :picker-options="durationPickerOptions" range-separator="至"
                  start-placeholder="开始时间" end-placeholder="结束时间" style="width: 100%;" />
              </el-form-item>
            </div>
          </article>

          <article class="editor-card">
            <div class="section-head">
              <div>
                <p class="section-eyebrow">Ad Set</p>
                <h2>受众与投放</h2>
              </div>
            </div>

            <div class="grid-two">
              <el-form-item label="兴趣爱好" prop="ad_set.name">
                <el-input v-model.trim="form.ad_set.name" placeholder="例如：移动端受众组" />
              </el-form-item>



              <el-form-item label="性别">
                <el-select v-model="form.ad_set.audience.gender">
                  <el-option label="全部" value="all" />
                  <el-option label="男" value="male" />
                  <el-option label="女" value="female" />
                </el-select>
              </el-form-item>

              <el-form-item label="投放地区">
                <button type="button" class="region-trigger" @click="openRegionDialog">
                  <span class="region-trigger__text">{{ regionSummaryText }}</span>
                  <span class="region-trigger__action">选择地区</span>
                </button>
              </el-form-item>

              <el-form-item label="年龄范围">
                <div class="age-block">
                  <div class="age-value">{{ ageRangeText }}</div>
                  <el-slider v-model="form.ad_set.audience.age" range :min="18" :max="60" :step="1"
                    :show-tooltip="false" />
                </div>
              </el-form-item>
            </div>
          </article>
        </div>

        <aside class="preview-column">
          <article class="preview-card">
            <div class="section-head">
              <div>
                <h2>实时预览</h2>
              </div>
            </div>

            <div class="preview-creative-bar">
              <div class="creative-tabs">
                <button v-for="ad in form.ads" :key="ad.slot" type="button" class="creative-tab"
                  :class="{ 'is-active': activeAdKey === String(ad.slot) }" @click="activateAd(ad.slot)">
                  {{ ad.name || (`素材 ${ad.slot}`) }}
                </button>
              </div>

              <div class="creative-actions">
                <el-button plain size="mini" :disabled="!canAddAd || isReadonlyAdminView"
                  @click="addAd">新增素材</el-button>
                <el-button v-if="form.ads.length > 1 && !isReadonlyAdminView" plain size="mini" type="danger"
                  @click="removeAd(activeAdSlot)">
                  删除当前素材
                </el-button>
              </div>
            </div>

            <div class="preview-shell">
              <div class="preview-brand">
                <div class="preview-avatar">{{ previewBrandInitial }}</div>
                <div>
                  <strong>{{ currentAd ? (currentAd.name || '品牌名称') : '品牌名称' }}</strong>
                  <!-- <span>{{ previewModeLabel }} · 推广投放</span> -->
                </div>
              </div>

              <div class="preview-media">
                <video v-if="currentAd && isVideoAd(currentAd) && currentAd.media_url" :src="currentAd.media_url" muted
                  playsinline controls />
                <img v-else-if="currentAd && currentAd.media_url" :src="currentAd.media_url" alt="" />
                <div v-else class="preview-empty">素材预览区</div>
              </div>

              <div class="preview-footer">
                <div>
                  <span>{{ previewHost }}</span>
                  <strong>{{ currentAd ? (currentAd.name || '素材名称') : '素材名称' }}</strong>
                </div>
                <a :href="previewLandingUrl" target="_blank" rel="noreferrer">
                  {{ currentAd ? ctaLabel(currentAd.cta) : '立即购买' }}
                </a>
              </div>
            </div>

            <template v-if="currentAd">
              <div class="creative-fields">
                <el-form-item>
                  <el-input v-model.trim="currentAd.primary_text" placeholder="请输入素材文案" />
                </el-form-item>
                <el-upload v-if="!isReadonlyAdminView" action="" :show-file-list="false" accept="image/*,video/*"
                  :http-request="request => uploadAdMedia(request, currentAd)" :disabled="!currentAd">
                  <el-button icon="el-icon-upload2" :loading="uploadingSlot === activeAdSlot">
                    上传素材
                  </el-button>
                </el-upload>
                <!-- <el-form-item label="素材">
                  <div class="upload-row">
                    <el-input
                      v-model.trim="currentAd.media_url"
                      placeholder="https://example.com/ad.jpg"
                    />
                    <el-upload v-if="!isReadonlyAdminView" action="" :show-file-list="false" accept="image/*,video/*"
                      :http-request="request => uploadAdMedia(request, currentAd)" :disabled="!currentAd">
                      <el-button icon="el-icon-upload2" :loading="uploadingSlot === activeAdSlot">
                        上传素材
                      </el-button>
                    </el-upload>
                  </div>
                </el-form-item> -->
              </div>
            </template>
          </article>
        </aside>
      </el-form>
    </section>

    <el-dialog title="选择投放地区" :visible.sync="regionDialogVisible" width="760px" custom-class="region-dialog"
      @open="syncRegionDraftSelection" @close="resetRegionDialog">
      <div class="region-dialog__toolbar">
        <el-input v-model.trim="regionKeyword" clearable placeholder="搜索国家名称或代码" prefix-icon="el-icon-search" />
        <span class="region-dialog__count">已选 {{ regionDraftSelection.length }} 个国家</span>
      </div>

      <div class="region-guides">
        <button v-for="guide in regionGuideOptions" :key="guide.value" type="button" class="region-guide"
          :class="{ 'is-active': activeRegionGuide === guide.value }" @click="activeRegionGuide = guide.value">
          {{ guide.label }}
        </button>
      </div>

      <div class="region-dialog__body">
        <div v-for="group in visibleRegionGroups" :key="group.key" class="region-group">
          <div class="region-group__title">{{ group.label }}</div>
          <el-checkbox-group v-model="regionDraftSelection" class="region-group__options">
            <el-checkbox v-for="item in group.items" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div slot="footer" class="region-dialog__footer">
        <el-button @click="regionDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRegionSelection">确认</el-button>
      </div>
    </el-dialog>
  </AdminShell>
</template>

<script>
import { getData as getCountryData } from 'country-list'
import {
  createPromotionCampaign,
  createPromotionPaymentOrder,
  deletePromotionCampaign,
  getPromotionCampaign,
  getUserInfo,
  updatePromotionCampaign,
  uploadPromotionFile,
} from '@/api'
import AdminShell from '@/components/admin/AdminShell.vue'
import {
  AGE_MAX,
  AGE_MIN,
  CTA_OPTIONS,
  OBJECTIVE_OPTIONS,
  PREVIEW_MODES,
  STATUS_OPTIONS,
  createAd,
  createDefaultForm,
  formatAgeRange,
  hasBillingSnapshotChanged,
  isVideoAd,
  normalizeBillingSnapshot,
  normalizeDetail,
  normalizeFormat,
  normalizeRegions,
  normalizeStatus,
  promotionStatusLabel,
  resolveCommercialId,
  validateAge,
} from '@/utils/promotion-form'

const regionDisplayNames = typeof Intl !== 'undefined' && Intl.DisplayNames
  ? new Intl.DisplayNames(['zh-CN'], { type: 'region' })
  : null

function getCountryDisplayName(code, fallbackName) {
  if (regionDisplayNames) {
    try {
      const localized = regionDisplayNames.of(code)
      if (localized) return localized
    } catch (_) { }
  }
  return fallbackName || code
}

const COUNTRY_OPTIONS = getCountryData()
  .map(item => ({
    value: item.code,
    label: `${getCountryDisplayName(item.code, item.name)} (${item.code})`,
    name: getCountryDisplayName(item.code, item.name),
  }))
  .sort((a, b) => a.label.localeCompare(b.label))

const REGION_GROUPS = [
  {
    key: 'asia',
    label: '亚洲',
    codes: ['AE', 'BD', 'BH', 'CN', 'HK', 'ID', 'IL', 'IN', 'JP', 'KH', 'KR', 'KZ', 'LA', 'LK', 'MM', 'MN', 'MO', 'MY', 'NP', 'OM', 'PH', 'PK', 'QA', 'SA', 'SG', 'TH', 'TR', 'TW', 'UZ', 'VN'],
  },
  {
    key: 'europe',
    label: '欧洲',
    codes: ['AL', 'AT', 'BA', 'BE', 'BG', 'BY', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LT', 'LU', 'LV', 'MD', 'ME', 'MK', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'SE', 'SI', 'SK', 'UA'],
  },
  {
    key: 'north-america',
    label: '北美洲',
    codes: ['BS', 'BB', 'CA', 'CR', 'DO', 'GT', 'HN', 'JM', 'MX', 'NI', 'PA', 'SV', 'TT', 'US'],
  },
  {
    key: 'south-america',
    label: '南美洲',
    codes: ['AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'GY', 'PE', 'PY', 'SR', 'UY', 'VE'],
  },
  {
    key: 'africa',
    label: '非洲',
    codes: ['DZ', 'BW', 'CM', 'CI', 'EG', 'ET', 'GH', 'KE', 'MA', 'MZ', 'NA', 'NG', 'SN', 'TN', 'TZ', 'UG', 'ZA', 'ZM', 'ZW'],
  },
  {
    key: 'oceania',
    label: '大洋洲',
    codes: ['AU', 'FJ', 'NZ', 'PG', 'SB', 'TO', 'VU', 'WS'],
  },
]

const REGION_GROUP_MAP = REGION_GROUPS.reduce((acc, group) => {
  group.codes.forEach(code => {
    acc[code] = group.key
  })
  return acc
}, {})

export default {
  name: 'PromotionEditorPage',
  components: {
    AdminShell,
  },
  data() {
    return {
      timeType: 0,
      pageLoading: false,
      saving: false,
      draftSaving: false,
      deleting: false,
      uploadingSlot: null,
      commercialId: '',
      form: createDefaultForm(),
      activeAdKey: '1',
      previewMode: 'feed',
      previewModes: PREVIEW_MODES,
      statusOptions: STATUS_OPTIONS,
      objectiveOptions: OBJECTIVE_OPTIONS,
      ctaOptions: CTA_OPTIONS,
      countryOptions: COUNTRY_OPTIONS,
      regionDialogVisible: false,
      regionDraftSelection: [],
      regionKeyword: '',
      activeRegionGuide: 'all',
      rules: {
        'campaign.name': [{ required: true, message: '请输入推广名称', trigger: 'blur' }],
        'campaign.objective': [{ required: true, message: '请选择推广目标', trigger: 'change' }],
        'ad_set.name': [{ required: true, message: '请输入兴趣爱好', trigger: 'blur' }],
      },
    }
  },
  computed: {
    URLlabel(){
      return this.form.campaign.objective == 'sales'? '落地链接(请添加whatsapp\\messager\\telegram\\line链接)' :'落地链接'
    },
    campaignId() {
      return Number(this.$route.params.id || 0)
    },
    isEditMode() {
      return this.campaignId > 0
    },
    pageTitle() {
      if (this.isReadonlyAdminView) return '推广详情'
      return this.isEditMode ? '编辑推广' : '新建推广'
    },
    pageSubtitle() {
      if (this.isReadonlyAdminView) return '管理员只读查看客户已启用推广。'
      return this.isEditMode
        ? '保存后仅在预算相关字段变化时生成或复用待支付账单。'
        : '首次保存会立即生成账单，随后进入支付流程。'
    },
    isReadonlyAdminView() {
      return String(this.commercialId) === '1' && this.$route.query.readonly === '1'
    },
    currentAd() {
      return this.form.ads.find(ad => String(ad.slot) === this.activeAdKey) || this.form.ads[0] || null
    },
    activeAdSlot() {
      return this.currentAd ? this.currentAd.slot : 1
    },
    canAddAd() {
      return this.form.ads.length < 3
    },
    previewBrandInitial() {
      const text = this.currentAd && this.currentAd.name ? this.currentAd.name.trim() : ''
      return text ? text.slice(0, 1).toUpperCase() : '素'
    },
    previewModeLabel() {
      const matched = this.previewModes.find(item => item.value === this.previewMode)
      return matched ? matched.label : 'Feed'
    },
    durationRange: {
      get() {
        if (!this.form.campaign.start_time || !this.form.campaign.end_time) return []
        return [this.form.campaign.start_time, this.form.campaign.end_time]
      },
      set(value) {
        const range = Array.isArray(value) ? value : []
        this.form.campaign.start_time = range[0] || ''
        this.form.campaign.end_time = range[1] || ''
      },
    },
    durationPickerOptions() {
      return {
        disabledDate: this.disablePastDurationDate,
        shortcuts: [
          { text: '增加 7 小时', onClick: picker => this.applyDurationShortcut(picker, 7) },
          { text: '半天', onClick: picker => this.applyDurationShortcut(picker, 12) },
        ],
      }
    },
    ageRangeText() {
      return formatAgeRange(this.form.ad_set.audience.age)
    },
    previewLandingUrl() {
      return this.resolveCreativeLandingUrl(this.currentAd) || '#'
    },
    previewHost() {
      const landingUrl = this.resolveCreativeLandingUrl(this.currentAd)
      if (!landingUrl) return 'EXAMPLE.COM'
      try {
        return new URL(landingUrl).hostname.toUpperCase()
      } catch (_) {
        return 'EXAMPLE.COM'
      }
    },
    regionGuideOptions() {
      return [
        { value: 'all', label: '全部' },
        ...REGION_GROUPS.map(group => ({ value: group.key, label: group.label })),
      ]
    },
    visibleRegionGroups() {
      const keyword = this.regionKeyword.trim().toLowerCase()
      const groups = REGION_GROUPS.map(group => ({
        key: group.key,
        label: group.label,
        items: this.countryOptions.filter(item => {
          const groupKey = REGION_GROUP_MAP[item.value] || 'other'
          if (groupKey !== group.key) return false
          if (this.activeRegionGuide !== 'all' && this.activeRegionGuide !== group.key) return false
          if (!keyword) return true
          return item.label.toLowerCase().includes(keyword) || item.value.toLowerCase().includes(keyword)
        }),
      })).filter(group => group.items.length)

      const otherItems = this.countryOptions.filter(item => {
        if (REGION_GROUP_MAP[item.value]) return false
        if (this.activeRegionGuide !== 'all' && this.activeRegionGuide !== 'other') return false
        if (!keyword) return true
        return item.label.toLowerCase().includes(keyword) || item.value.toLowerCase().includes(keyword)
      })

      if (otherItems.length) {
        groups.push({
          key: 'other',
          label: '其他地区',
          items: otherItems,
        })
      }

      return groups
    },
    regionSummaryText() {
      const selected = normalizeRegions(this.form.ad_set.audience.regions)
      if (!selected.length) return '请选择投放国家'

      const labels = selected
        .map(code => {
          const item = this.countryOptions.find(option => option.value === code)
          return item ? item.name : code
        })
        .filter(Boolean)

      if (labels.length <= 3) return labels.join('、')
      return `${labels.slice(0, 3).join('、')} 等 ${labels.length} 个国家`
    },
  },
  async mounted() {
    await this.initialize()
  },
  watch: {
    '$route.fullPath': {
      async handler() {
        await this.initialize()
      },
    },
  },
  methods: {
    async initialize() {
      this.pageLoading = true
      try {
        await this.loadCommercialId()
        await this.loadCampaign()
      } finally {
        this.pageLoading = false
      }
    },
    async loadCommercialId() {
      const { data } = await getUserInfo()
      this.commercialId = String(resolveCommercialId(data) || '')
      this.form.commercial_id = this.commercialId
    },
    async loadCampaign() {
      if (!this.isEditMode) {
        this.form = createDefaultForm(this.commercialId)
        this.activeAdKey = '1'
        this.timeType = 0
        return
      }

      try {
        const res = await getPromotionCampaign(this.campaignId, this.commercialId)
        this.form = normalizeDetail(res && res.data, this.commercialId)
        this.activeAdKey = String((this.form.ads[0] || {}).slot || 1)
        this.timeType = this.form.campaign.start_time && this.form.campaign.end_time ? 1 : 0
      } catch (error) {
        this.$message.error(error.message || '加载推广详情失败')
      }
    },
    disablePastDurationDate(time) {
      const now = new Date()
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
      return time.getTime() < todayStart
    },
    applyDurationShortcut(picker, hours) {
      const start = new Date(Date.now() + 5 * 60 * 1000)
      const end = new Date(start.getTime() + hours * 60 * 60 * 1000)
      picker.$emit('pick', [start, end])
    },
    goToList() {
      if (this.$route.query.from === 'notifications') {
        this.$router.push({
          path: '/promotion',
          query: {
            view: 'pending-promotions',
          },
        })
        return
      }
      this.$router.push('/promotion')
    },
    goToBills() {
      if (!this.form.id) return
      this.$router.push(`/promotion/${this.form.id}/bills`)
    },
    openRegionDialog() {
      this.syncRegionDraftSelection()
      this.regionDialogVisible = true
    },
    syncRegionDraftSelection() {
      this.regionDraftSelection = normalizeRegions(this.form.ad_set.audience.regions)
    },
    resetRegionDialog() {
      this.regionKeyword = ''
      this.activeRegionGuide = 'all'
      this.regionDraftSelection = []
    },
    confirmRegionSelection() {
      this.form.ad_set.audience.regions = normalizeRegions(this.regionDraftSelection)
      this.regionDialogVisible = false
    },
    activateAd(slot) {
      this.activeAdKey = String(slot)
    },
    normalizeFormAds() {
      this.form.ads = this.form.ads.map((ad, index) => ({
        ...createAd(index + 1),
        ...ad,
        slot: index + 1,
        status: normalizeStatus(ad.status),
        format: normalizeFormat(ad.format),
        landing_url: ad.landing_url || this.form.ad_set.landing_url || '',
        utm: {
          ...createAd(index + 1).utm,
          ...(ad.utm || {}),
        },
      }))
      if (!this.form.ads.some(ad => String(ad.slot) === this.activeAdKey)) {
        this.activeAdKey = String((this.form.ads[0] || {}).slot || 1)
      }
    },
    addAd() {
      if (!this.canAddAd) return
      const nextSlot = this.form.ads.length + 1
      this.form.ads.push(createAd(nextSlot))
      this.activeAdKey = String(nextSlot)
    },
    removeAd(slot) {
      if (this.form.ads.length <= 1) return
      this.form.ads = this.form.ads.filter(ad => ad.slot !== slot)
      this.normalizeFormAds()
    },
    resolveCreativeLandingUrl(ad) {
      if (ad && ad.landing_url) return ad.landing_url
      return this.form.ad_set.landing_url || ''
    },
    async uploadAdMedia(request, ad) {
      const file = request.file
      if (!file || !ad) return
      this.uploadingSlot = ad.slot
      const formData = new FormData()
      formData.append('newfile', file)
      formData.append('mode', 'add')
      formData.append('currentpath', '/')
      try {
        const res = await uploadPromotionFile(formData)
        const url = res && res.data && res.data.url ? res.data.url : ''
        if (!url) throw new Error('上传结果缺少 url')
        ad.media_url = url
        ad.format = file.type && file.type.indexOf('video') === 0 ? 'video' : 'image'
        this.$message.success('素材上传成功')
      } catch (error) {
        this.$message.error(error.message || '素材上传失败')
      } finally {
        this.uploadingSlot = null
      }
    },
    validateBusinessRules() {
      this.normalizeFormAds()
      if (!this.commercialId) {
        this.$message.error('缺少 commercial_id')
        return false
      }
      if (this.form.ads.length < 1 || this.form.ads.length > 3) {
        this.$message.error('素材数量必须在 1 到 3 个之间')
        return false
      }
      if (!validateAge(this.form.ad_set.audience.age)) {
        this.$message.error('年龄范围必须在 18 到 60 之间')
        return false
      }
      if (!this.form.ad_set.audience.regions.length) {
        this.$message.error('请至少选择一个投放国家')
        return false
      }
      if (Number(this.form.campaign.budget_amount || 0) < 1) {
        this.$message.error('预算金额不能低于 50')
        return false
      }
      if (!String(this.form.ad_set.landing_url || '').trim()) {
        this.$message.error('请填写统一落地链接')
        return false
      }

      if (this.timeType !== 0) {
        const startAt = new Date(this.form.campaign.start_time).getTime()
        const endAt = new Date(this.form.campaign.end_time).getTime()
        const now = Date.now()
        if (!startAt || !endAt || Number.isNaN(startAt) || Number.isNaN(endAt)) {
          this.$message.error('请选择完整的推广时长')
          return false
        }
        if (startAt <= now || endAt <= now) {
          this.$message.error('推广时长必须是未来时间')
          return false
        }
        if (endAt <= startAt) {
          this.$message.error('结束时间必须晚于开始时间')
          return false
        }
      }

      const invalidAd = this.form.ads.find(ad => {
        if (!['image', 'video'].includes(ad.format)) return true
        if (this.form.campaign.status !== 'active' || ad.status !== 'active') return false
        return !ad.media_url || !this.resolveCreativeLandingUrl(ad)
      })

      if (!invalidAd) return true

      if (!['image', 'video'].includes(invalidAd.format)) {
        this.$message.error(`素材 ${invalidAd.slot} 的类型不合法`)
        return false
      }
      this.$message.error(`素材 ${invalidAd.slot} 缺少素材或落地链接`)
      return false
    },
    buildPayload(status) {
      this.normalizeFormAds()
      const sharedLandingUrl = String(this.form.ad_set.landing_url || '').trim()
      const ageRange = this.form.ad_set.audience.age || [AGE_MIN, AGE_MAX]
      const isLongTerm = Number(this.timeType) === 0

      return {
        commercial_id: this.commercialId,
        campaign_name: String(this.form.campaign.name || '').trim(),
        objective: String(this.form.campaign.objective || '').trim(),
        status,
        budget_type: String(this.form.campaign.budget_type || 'daily').trim() || 'daily',
        budget_amount: Number(this.form.campaign.budget_amount || 0),
        currency: String(this.form.campaign.currency || 'USD').trim().toUpperCase() || 'USD',
        start_time: isLongTerm ? '' : (this.form.campaign.start_time || ''),
        end_time: isLongTerm ? '' : (this.form.campaign.end_time || ''),
        interest_name: String(this.form.ad_set.name || '').trim(),
        conversion_location: String(this.form.ad_set.conversion_location || 'website').trim() || 'website',
        optimization_goal: String(this.form.ad_set.optimization_goal || 'landing_page_views').trim() || 'landing_page_views',
        landing_url: sharedLandingUrl,
        gender: String(this.form.ad_set.audience.gender || 'all').trim() || 'all',
        regions: normalizeRegions(this.form.ad_set.audience.regions),
        age: `${ageRange[0]}-${ageRange[1]}`,
        creatives: this.form.ads.map((ad, index) => {
          const creativeName = String(ad.name || `素材 ${index + 1}`).trim()
          return {
            creative_name: creativeName,
            status: normalizeStatus(ad.status),
            format: normalizeFormat(ad.format),
            media_url: String(ad.media_url || '').trim(),
            headline: String(ad.headline || creativeName).trim(),
            primary_text: String(ad.primary_text || creativeName).trim(),
            description: String(ad.description || creativeName).trim(),
            cta: String(ad.cta || 'Shop Now').trim() || 'Shop Now',
            landing_url: String(this.resolveCreativeLandingUrl(ad) || '').trim(),
          }
        }),
      }
    },
    async persistCampaign(status) {
      await new Promise((resolve, reject) => {
        this.$refs.formRef.validate(valid => {
          if (!valid) {
            reject(new Error('表单校验未通过'))
            return
          }
          if (!this.validateBusinessRules()) {
            reject(new Error('业务校验未通过'))
            return
          }
          resolve()
        })
      })

      const payload = this.buildPayload(status)
      const res = this.form.id
        ? await updatePromotionCampaign(this.form.id, payload)
        : await createPromotionCampaign(payload)
      this.form = normalizeDetail(res && res.data, this.commercialId)
      this.activeAdKey = String((this.form.ads[0] || {}).slot || 1)
      this.timeType = this.form.campaign.start_time && this.form.campaign.end_time ? 1 : 0
      return this.form
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        const savedForm = await this.persistCampaign('draft')
        this.$router.push({
          path: '/promotion',
          query: {
            saved: '1',
            draftSaved: '1',
            campaignId: savedForm.id,
          },
        })
      } catch (error) {
        this.$message.error(error.message || '保存草稿失败')
      } finally {
        this.draftSaving = false
      }
    },
    async savePromotion() {
      this.saving = true
      const beforeSnapshot = this.form.id ? normalizeBillingSnapshot(this.form) : null
      const targetStatus = this.form.id ? (this.form.campaign.status || 'draft') : 'draft'

      try {
        const savedForm = await this.persistCampaign(targetStatus)
        const afterSnapshot = normalizeBillingSnapshot(savedForm)
        const shouldCreateBill = !beforeSnapshot || hasBillingSnapshotChanged(beforeSnapshot, afterSnapshot)

        if (!shouldCreateBill) {
          this.$router.push({
            path: '/promotion',
            query: {
              saved: '1',
              campaignId: savedForm.id,
            },
          })
          return
        }

        const paymentRes = await createPromotionPaymentOrder(savedForm.id, this.commercialId)
        const order = paymentRes && paymentRes.data ? paymentRes.data : {}
        this.$router.push({
          path: `/promotion/${savedForm.id}/bills`,
          query: {
            focusOrderId: order.id,
            billCreated: '1',
            reused: order.reused_existing ? '1' : '0',
          },
        })
      } catch (error) {
        this.$message.error(error.message || '保存推广失败')
      } finally {
        this.saving = false
      }
    },
    async deleteCurrent() {
      if (!this.form.id) return
      try {
        await this.$confirm('确认删除当前推广吗？', '提示', { type: 'warning' })
      } catch (_) {
        return
      }

      this.deleting = true
      try {
        await deletePromotionCampaign({
          id: this.form.id,
          commercial_id: this.commercialId,
        })
        this.$message.success('推广已删除')
        this.$router.push('/promotion')
      } catch (error) {
        this.$message.error(error.message || '删除推广失败')
      } finally {
        this.deleting = false
      }
    },
    statusLabel(value) {
      return promotionStatusLabel(value)
    },
    ctaLabel(value) {
      const matched = this.ctaOptions.find(item => item.value === value)
      return matched ? matched.label : (value || '立即购买')
    },
    isVideoAd,
  },
}
</script>

<style scoped>
.promotion-editor-page {
  display: grid;
}

.editor-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 20px;
  align-items: start;
}

.editor-form,
.preview-column {
  display: grid;
  gap: 18px;
}

.editor-card,
.preview-card {
  border: 1px solid #dbe4f0;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
  padding: 24px;
}

.editor-form :deep(.el-select),
.editor-form :deep(.el-slider) {
  width: 100%;
}

.age-block {
  display: grid;
  gap: 10px;
}

.age-value {
  color: #1d4ed8;
  font-weight: 700;
}

.region-trigger {
  width: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  color: #0f172a;
}

.region-trigger__text {
  text-align: left;
}

.region-trigger__action {
  color: #2563eb;
  white-space: nowrap;
}

.region-dialog__toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.region-dialog__toolbar .el-input {
  flex: 1;
}

.region-dialog__count {
  color: #64748b;
  white-space: nowrap;
}

.region-guides {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 16px;
}

.region-guide {
  border: 1px solid #d0d8e5;
  border-radius: 999px;
  background: #f8fafc;
  color: #475569;
  padding: 8px 14px;
  cursor: pointer;
}

.region-guide.is-active {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.1);
  color: #1d4ed8;
}

.region-dialog__body {
  max-height: 480px;
  overflow: auto;
  display: grid;
  gap: 18px;
  padding-right: 4px;
}

.region-group {
  display: grid;
  gap: 12px;
}

.region-group__title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
}

.region-group__options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 16px;
}

.region-dialog__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.section-head,
.preview-brand,
.preview-footer,
.upload-row,
.creative-actions {
  display: flex;
  align-items: center;
}

.section-head {
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.section-eyebrow {
  color: #64748b;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.section-head h2 {
  color: #0f172a;
  font-size: 22px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 84px;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-pill.is-draft {
  color: #475569;
  background: #e2e8f0;
}

.status-pill.is-active {
  color: #166534;
  background: #dcfce7;
}

.status-pill.is-paused {
  color: #9a3412;
  background: #ffedd5;
}

.status-pill.is-archived {
  color: #7c3aed;
  background: #ede9fe;
}

.grid-two {
  display: grid;
  gap: 12px 16px;
}

.grid-two :deep(.el-form-item) {
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 12px;
}

.grid-two :deep(.el-input .el-input__inner),
.grid-two :deep(.el-textarea__inner) {
  border: none;
}

.grid-two :deep(.el-form-item__label) {
  line-height: 1.4;
}

.creative-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.preview-creative-bar {
  display: grid;
  gap: 12px;
  margin-bottom: 18px;
  padding: 14px;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  background: #f8fafc;
}

.preview-creative-bar .creative-tabs {
  margin-bottom: 0;
}

.preview-creative-bar .creative-actions {
  justify-content: flex-end;
  gap: 10px;
}

.creative-tab {
  border: 1px solid #d0d8e5;
  border-radius: 999px;
  background: #f8fafc;
  color: #475569;
  padding: 8px 14px;
  cursor: pointer;
}

.creative-tab.is-active {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.1);
  color: #1d4ed8;
}

.upload-row {
  gap: 12px;
}

.upload-row .el-input {
  flex: 1;
}

.creative-fields {
  display: grid;
  gap: 12px;
  margin-top: 18px;
}

.creative-fields :deep(.el-form-item) {
  margin-bottom: 0;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 12px;
}

.creative-fields :deep(.el-input .el-input__inner) {
  border: none;
}

.creative-fields :deep(.el-form-item__label) {
  line-height: 1.4;
}

.preview-shell {
  display: grid;
  gap: 16px;
}

.preview-brand {
  gap: 12px;
}

.preview-avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: linear-gradient(135deg, #2563eb, #0f172a);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
}

.preview-brand strong,
.preview-footer strong {
  display: block;
  color: #0f172a;
}

.preview-brand span,
.preview-footer span,
.preview-copy {
  color: #64748b;
}

.preview-media {
  min-height: 260px;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(135deg, #e2e8f0, #f8fafc);
}

.preview-media img,
.preview-media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-empty {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.preview-footer {
  justify-content: space-between;
  gap: 12px;
}

.preview-footer a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-radius: 999px;
  background: #0f172a;
  color: #fff;
  text-decoration: none;
}

@media (max-width: 1080px) {

  .editor-layout,
  .grid-two,
  .region-group__options {
    grid-template-columns: 1fr;
  }

  .region-dialog__toolbar {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
